import axios from '../javascript/custom-axios'
const V1 = '/v1'
const RESOURCE_NAME = '/surveys'

export default {
    getSurveys(Page, PageSize) {
        return axios.get(`${V1}${RESOURCE_NAME}?Page=${Page}&PageSize=${PageSize}&Status=${20}`)
    },

    setAnswerSurvey(body) {
        return axios.post(`${V1}${RESOURCE_NAME}/answers`, body)
    },

    getAnswerSurvey(UserId) {
        return axios.get(`${V1}${RESOURCE_NAME}/answers?UserId=${UserId}`)
    },

    getSurveyDetail(id){
        return axios.get(`${V1}${RESOURCE_NAME}/details/${id}`)
    },

    getSurveyAnswersWithSurveyId(UserId, SurveyId) {
        return axios.get(`${V1}${RESOURCE_NAME}/answers?UserId=${UserId}&SurveyId=${SurveyId}`)
    },
}
